export default {
  path: '/fulfillments',
  name: 'fulfillments',
  component: () => import('../components/Layout'),
  redirect: { name: 'FulfillmentList' },
  children: [
    {
      name: 'FulfillmentList',
      path: '',
      component: () => import('../views/fulfillment/List')
    }
  ]
}
